module.exports = __webpack_public_path__ + "img/39-02.db1906c4.png";